import React from 'react'
import Link from 'gatsby-link'
import logo3 from '../../images/logo_square.png'

const Header = () => (
  <nav className="navbar navbar-default navbar-static-top">
    <div className="container-fluid">
      <div className="navbar-header">
        <button
          type="button"
          className="navbar-toggle collapsed hidden-xs"
          data-toggle="collapse"
          data-target="#navbar"
          aria-expanded="false"
          aria-controls="navbar"
        >
          <span className="sr-only">Toggle navigation</span>
          <span className="icon-bar" />
          <span className="icon-bar" />
          <span className="icon-bar" />
        </button>
        <a className="navbar-brand" href="/">
          <img src={logo3} />
        </a>
      </div>
      <div id="navbar" className="collapse navbar-collapse pull-right">
        <ul className="nav navbar-nav">
          <li>
            <a href="/">Home</a>
          </li>
          <li>
            <a href="/#contact">Contact</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/BlogHeader/index.js